import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-8c6d85c0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "w-full h-[calc(100%-50px)] bg-[#f8f8f8] mt-[50px] absolute top-0 left-0 z-[99] overflow-hidden"
};
var _hoisted_2 = {
  class: "flex"
};
var _hoisted_3 = {
  class: "w-6/12 flex flex-row-reverse"
};
var _hoisted_4 = {
  class: "w-6/12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Transition, {
    name: "song-detail",
    persisted: true,
    mode: "out-in"
  }, {
    default: _withCtx(function () {
      var _$setup$currentSong;

      return [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createCommentVNode(" 歌词封面（播放时旋转） "), $setup.currentSong ? (_openBlock(), _createBlock($setup["RotateCover"], {
        key: 0,
        class: "mr-16 mt-16",
        img: (_$setup$currentSong = $setup.currentSong) === null || _$setup$currentSong === void 0 ? void 0 : _$setup$currentSong.coverImg
      }, null, 8
      /* PROPS */
      , ["img"])) : _createCommentVNode("v-if", true)]), _createElementVNode("div", _hoisted_4, [_createCommentVNode(" 歌词组件（词曲作者、歌词） "), $setup.currentSong ? (_openBlock(), _createBlock($setup["SongLyric"], {
        key: 0,
        song: $setup.currentSong,
        lyric: $setup.lyricState.lyric,
        transLyric: $setup.lyricState.transLyric,
        lyricUser: $setup.lyricState.lyricUser,
        transLyricUser: $setup.lyricState.transLyricUser
      }, null, 8
      /* PROPS */
      , ["song", "lyric", "transLyric", "lyricUser", "transLyricUser"])) : _createCommentVNode("v-if", true)])]), _createCommentVNode(" 歌曲评论 "), _createCommentVNode(" 包含该歌曲的歌单 "), _createCommentVNode(" 相似歌曲 ")], 512
      /* NEED_PATCH */
      ), [[_vShow, $setup.isShowSongDetail]])];
    }),
    _: 1
    /* STABLE */

  });
}